import React, { JSX, useState } from 'react';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import {
  DeleteBlackIcon,
  EditBlackIcon,
  MoreIcon,
  EyIcon
} from '@components/icons/svg-icon.tsx';
import { useTranslation } from 'react-i18next';
import { ActionProps } from '@models/table.model.ts';

const RowActions = <T,>({
  row,
  handleEdit,
  handleDelete,
  handlePreview,
  hidePreview,
  hideDelete
}: ActionProps<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useTranslation();

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className="!p-0 !h-[20px] !w-[20px]"
        disableRipple
        onClick={handleClickMenu}
      >
        <MoreIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        sx={{ minWidth: 200 }}
      >
        {handleEdit && (
          <MenuItem
            onClick={() => {
              handleEdit(row);
              handleCloseMenu();
            }}
          >
            <ListItemIcon
              sx={{
                backgroundColor: 'var(--gray-11)',
                minWidth: '30px !important',
                height: 30,
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <EditBlackIcon />
            </ListItemIcon>
            {t('edit')}
          </MenuItem>
        )}

        {!hidePreview && handlePreview && (
          <MenuItem
            onClick={() => {
              handlePreview(row);
              handleCloseMenu();
            }}
          >
            <ListItemIcon
              sx={{
                backgroundColor: 'var(--gray-11)',
                minWidth: '30px !important',
                height: 30,
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <EyIcon />
            </ListItemIcon>
            {t('preview')}
          </MenuItem>
        )}

        {!hideDelete && handleDelete && (
          <MenuItem
            onClick={() => {
              handleDelete(row);
              handleCloseMenu();
            }}
          >
            <ListItemIcon
              sx={{
                backgroundColor: 'var(--gray-11)',
                minWidth: '30px !important',
                height: 30,
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <DeleteBlackIcon />
            </ListItemIcon>
            {t('delete')}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default RowActions as <T>(props: ActionProps<T>) => JSX.Element;
